import '../List/Style.less';

/**
 * Хүргэлтийн захиалгын төлвийн badge.
 * Жагсаалт болон дэлгэрэнгүй дээр адилхан харагдана.
 *
 * @param status - orderStatus-ийн эх утга (class-д хэрэглэгдэнэ)
 * @param label  - enumDictionary-с гарсан харагдах текст
 */
const DeliveryStatusBadge = ({ status, label }) => {
  if (!status) return null;

  return (
    <span className={`delivery-status-badge delivery-status-${status}`}>
      <span className="delivery-status-dot" />
      {label ?? status}
    </span>
  );
};

export default DeliveryStatusBadge;
